goog.provide("shadow.js.shim.module$src$svg$organisations$other$tiktok_svg$default");
shadow.js.shim.module$src$svg$organisations$other$tiktok_svg$default = shadow.js.shim.module$src$svg$organisations$other$tiktok_svg.default;
